import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CustomPagination from "../CustomPagination";
import LoaderTable from "../../hooks/loaderTable";
import useSocket from "../SocketIo";
import { MARKET_STATUS, MARKET_STATUS_TEXT_COLORS } from "../../utils/MarketStatus";
import { useTranslation } from "react-i18next";
import { getPredictedMarkets, getProfilePnl } from "../../utils/services";
import { convertFromMweiToFIxed, getPoolsStatus, truncateLongTexts, convertFromWei, convertFromWeiEthers, getTokenSymbol, formatNumberWithCommas, getMarketToken } from "../../utils/helpers";
import { ALL_MARKETS } from "../../utils/constants";
import { detailPath } from "../../constants/Routes";

const MyPredictedMarkets = ({ activeKey, selectedMarketFilter }) => {
    const { investments, setInvestMents } = useSocket();
    const [loadertable, setLoaderTable] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [perpoolPnl, setPerPoolPnl] = useState([]);
    const { t } = useTranslation();

    const getPerPoolPnl = async () => {
        try {
            const response = await getProfilePnl()
            setPerPoolPnl(response || []);
        } catch (error) {
            console.log("An error occurred while updating profile.");
        }
    };

    const getMyInvestments = async (offset = 1, status) => {
        setLoaderTable(true);
        try {
            const response = await getPredictedMarkets(offset, status)
            setInvestMents(response);
            setTotalPages(response.pages);
        } catch (error) {
            console.error("Error fetching pools:", error);
        } finally {
            setLoaderTable(false);
        }
    };

    useEffect(() => {
   const token = localStorage.getItem("accessToken");
  if (!token) return;
  
  const status = getPoolsStatus(selectedMarketFilter || ALL_MARKETS);
  const fetchData = async () => {
    await getMyInvestments(currentPage, status);
    await getPerPoolPnl()
  };

  fetchData();
}, [currentPage, activeKey, selectedMarketFilter]);

    const handlePageChange = (page) => {
        const status = getPoolsStatus(selectedMarketFilter || ALL_MARKETS);
        setCurrentPage(page);
        getMyInvestments(page, status);
    };

    return (
        <div className="inner-tab-content inner-tab-content-prediction">
            {loadertable ? (
                <div className="pb-5 pt-5">
                    <LoaderTable />
                </div>
            ) : investments?.pools && investments?.pools?.length > 0 ? (
                investments?.pools?.map((investmentData, index) => {
                    const indexcount = (currentPage - 1) * 10 + index + 1;
                    const pool = investmentData.pool;

                    const matchingPnl = perpoolPnl?.find(
                        (pnlData) => pnlData.pool === pool?._id
                    );

                    return (
                        <Link to={detailPath(pool._id)} key={index}>
                            <div className="inner-row">
                                <div className="rowleft">
                                    <div className="rowleftinner serial">
                                        <p className="rowpara">{t("No")}.</p>
                                        <h5 className="rowmainhead">{indexcount}</h5>
                                    </div>

                                    <div className="rowleftinner">
                                        <p className="rowpara">{t("Question")}</p>
                                        <h5 className="rowmainhead">
                                            {truncateLongTexts(pool?.question, 25)}
                                        </h5>
                                    </div>
                                </div>

                                <div className="rowright">
                                    <div className="rowrightmain">
                                        <div className="rowrightinner">
                                            <p className="rowpara">{t(`Amount (${getMarketToken(investmentData?.pool?.token).label})`)}</p>
                                            <h6 className="rowrighthead">
                                                {getTokenSymbol(investmentData?.pool?.token?.tokenSymbol)}{formatNumberWithCommas(convertFromWeiEthers(investmentData?.amount, investmentData?.pool?.token?.tokenDecimals))}
                                            </h6>
                                        </div>

                                        <div className="rowrightinner">
                                            <p className="rowpara">{t("PnL")}</p>
                                            <h6
                                                className="rowrighthead"
                                                style={{
                                                    color:
                                                        matchingPnl?.pnl > 0
                                                            ? "var(--green-text)"
                                                            : "var(--logout-text)",
                                                }}
                                            >
                                                {matchingPnl
                                                    ? !isNaN(matchingPnl.pnl)
                                                        ? parseFloat(
                                                            convertFromWeiEthers(
                                                                matchingPnl.pnl.toString(),
                                                                pool?.token?.tokenDecimals
                                                            )
                                                        )
                                                            .toFixed(2)
                                                            .replace(
                                                                /\B(?=(\d{3})+(?!\d))/g,
                                                                ","
                                                            )
                                                        : "N/A"
                                                    : "N/A"}
                                            </h6>
                                        </div>

                                        <div className="rowrightinner" style={{ minWidth: "150px" }}>
                                            <p className="rowpara">{t("Status")}</p>
                                            <h6
                                                style={{
                                                    color:
                                                        MARKET_STATUS_TEXT_COLORS[
                                                        investmentData?.status
                                                        ],
                                                }}
                                            >
                                                {t(MARKET_STATUS[investmentData?.status])}
                                            </h6>
                                        </div>
                                    </div>

                                    <div className="rowrightmain mbldirection">
                                        <div className="rowrightinner">
                                            <Link to={detailPath(pool._id)}>
                                                <button className="dullbtn">
                                                    {t("Go To Market")}
                                                </button>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    );
                })
            ) : (
                <div className="whennopolls">
                    <p>{t("No Markets Found")}</p>
                </div>
            )}

            <div className="paginationmain">
                {!loadertable && investments?.pools?.length > 0 && (
                    <CustomPagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    />
                )}
            </div>
        </div>
    );
};

export default MyPredictedMarkets;
